/**
 * Console prototype: when REACT_APP_DEBUG !== 'true', console.log is a no-op.
 * Replaces caribe7/modules/logging/log-proto.js.
 */

const consoleProto = {
  ...console,
  sups: console,
  log(...args: unknown[]) {
    if (process.env.REACT_APP_DEBUG === 'true') {
      this.sups.log.apply(this, [...args]);
    }
    return true;
  },
};

// eslint-disable-next-line no-global-assign
(window as unknown as Record<string, unknown>).console = consoleProto;
